import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {InformType} from '../../../../global/util/enum/InformType';
import {Document} from '../../../model/Document';
import {DocumentService} from '../../../service/document.service';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {Person} from '../../../model/Person';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-finalize-document',
  templateUrl: './finalize-document.component.html',
  styleUrls: ['./finalize-document.component.css']
})
export class FinalizeDocumentComponent {

  public people: Person[];
  public document: Document;
  public loading: boolean;

  constructor(private activeModal: NgbActiveModal,
              public documentService: DocumentService,
              private modalService: NgbModal,
              private translate: TranslateService) {
  }

  public cancel() {
    this.activeModal.close(FinalizeDocumentComponent);
  }

  public getOperationDescription(person: Person): string {
    if (person._more) {
      return person._more.operationDescription;
    }
  }

  public isSigner(person: any) {
    if (person._more) {
      return Constant.SIGN_OPTION === person._more.operationId;
    }
  }

  public finalizeDocument() {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.FINALIZE-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-FINALIZE-DOCUMENT');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.loading = true;
        const url = Constant.ROOT_API_V1
          .concat('/documents/')
          .concat(String(this.document.id))
          .concat('/finalize');
        this.documentService.finalize(url).subscribe(next => {
          this.loading = false;
          this.activeModal.close(InformType.Success);
        }, error => {
          this.loading = false;
          this.activeModal.close(InformType.Danger);
        });
      }
    });
  }

  get isThereSomeOperationCompleted(): boolean {
    return !(this.people.find(person => this.isOperationComplete(person)) !== undefined);
  }

  public isOperationComplete(person: Person): boolean {
    return Constant.COMPLETED === person._more.operationCompleted;
  }
}
